/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type WorkflowPauseState = (typeof WorkflowPauseState)[keyof typeof WorkflowPauseState];

export const WorkflowPauseState = {
  Running: 0,
  Pausing: 1,
  Paused: 2,
} as const;
